import { useEffect, useMemo, useState } from 'react'

export type TimeLeft = {
  hours: string
  minutes: string
  seconds: string
  isOver: boolean
}

const pad = (value: number): string => String(Math.max(0, value)).padStart(2, '0')

/**
 * Countdown shared across the page. The deadline is created once per session
 * so every timer on the page stays in sync.
 */
export function useCountdown(durationMs: number = 1000 * 60 * 60 * 11 + 1000 * 60 * 42): TimeLeft {
  const deadline = useMemo(() => Date.now() + durationMs, [durationMs])
  const [now, setNow] = useState<number>(() => Date.now())

  useEffect(() => {
    const id = window.setInterval(() => setNow(Date.now()), 1000)
    return () => window.clearInterval(id)
  }, [])

  const remaining = Math.max(0, deadline - now)
  const totalSeconds = Math.floor(remaining / 1000)

  return {
    hours: pad(Math.floor(totalSeconds / 3600)),
    minutes: pad(Math.floor((totalSeconds % 3600) / 60)),
    seconds: pad(totalSeconds % 60),
    isOver: remaining === 0,
  }
}
